import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';
import { u as useKeyboardClick } from './utils.js';

const mapyMapButtonCss = ":host{background:#ffffff;color:rgba(1, 30, 57, 0.6);border-radius:8px;box-shadow:0px 4px 16px 0px rgba(0, 0, 0, 0.10);user-select:none;display:inline-flex;padding:4px 8px;align-items:center;gap:8px;font-family:Arial, Helvetica, sans-serif;font-size:14px;font-style:normal;font-weight:400;line-height:20px;cursor:pointer;min-height:24px}:host(:hover:not([disabled])),:host(:focus-visible){background:#f5f6f7}:host(:active:not([disabled])){color:rgba(30, 174, 0, 1)}:host(:hover:active:not([disabled])){color:rgba(27, 157, 0, 1)}:host(:focus-visible){outline:2px solid currentColor}:host([disabled]){color:rgba(1, 30, 57, 0.12);pointer-events:none;cursor:default}";

var __classPrivateFieldGet = (undefined && undefined.__classPrivateFieldGet) || function (receiver, state, kind, f) {
  if (kind === "a" && !f)
    throw new TypeError("Private accessor was defined without a getter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver))
    throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (undefined && undefined.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
  if (kind === "m")
    throw new TypeError("Private method is not writable");
  if (kind === "a" && !f)
    throw new TypeError("Private accessor was defined without a setter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver))
    throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _MapyMapButton_originalTabIndex, _MapyMapButton_cleanup;
const MapyMapButton$1 = /*@__PURE__*/ proxyCustomElement(class MapyMapButton extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    _MapyMapButton_originalTabIndex.set(this, undefined);
    _MapyMapButton_cleanup.set(this, null);
    this.disabled = false;
  }
  watchPropHandler(newValue) {
    if (newValue) {
      this.hostElement.tabIndex = -1;
    }
    else {
      this.hostElement.tabIndex = __classPrivateFieldGet(this, _MapyMapButton_originalTabIndex, "f");
    }
  }
  connectedCallback() {
    __classPrivateFieldSet(this, _MapyMapButton_cleanup, useKeyboardClick(this.hostElement), "f");
    if (!this.hostElement.hasAttribute('tabindex')) {
      this.hostElement.tabIndex = 0;
    }
    __classPrivateFieldSet(this, _MapyMapButton_originalTabIndex, this.hostElement.getAttribute('tabindex'), "f");
    if (this.disabled) {
      this.hostElement.tabIndex = -1;
    }
  }
  disconnectedCallback() {
    var _a;
    (_a = __classPrivateFieldGet(this, _MapyMapButton_cleanup, "f")) === null || _a === void 0 ? void 0 : _a.call(this);
  }
  render() {
    return h(Host, null, h("slot", null));
  }
  get hostElement() { return this; }
  static get watchers() { return {
    "disabled": ["watchPropHandler"]
  }; }
  static get style() { return mapyMapButtonCss; }
}, [1, "mapy-map-button", {
    "disabled": [516]
  }]);
_MapyMapButton_originalTabIndex = new WeakMap(), _MapyMapButton_cleanup = new WeakMap();
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["mapy-map-button"];
  components.forEach(tagName => { switch (tagName) {
    case "mapy-map-button":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, MapyMapButton$1);
      }
      break;
  } });
}
defineCustomElement$1();

const MapyMapButton = MapyMapButton$1;
const defineCustomElement = defineCustomElement$1;

export { MapyMapButton, defineCustomElement };

//# sourceMappingURL=mapy-map-button.js.map